import { get } from './P3Api';

class CategoryGroupSubgroup2Api {
  static async getCategoryGroupSubgroup2(categoryId, groupId) {
    return get(`categories/${categoryId}/groups/${groupId}/subgroup/2`);
  }
}

export default CategoryGroupSubgroup2Api;
